module.exports = __webpack_public_path__ + "img/img_tutorial_03.9ae8ce19.svg";